import React from "react";
import PropTypes from "prop-types";
import Popup from "~/assets/js/components/Popup";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";

const EarlyOnLocationInfo = ({ open, handleClose }) => {
    const PopupConfig = {
        title: i18n.t("timeSlotSelect.earlyOnSite.info.title"),
        customStyle: "early-on-location-info",
        open: open,
        isInfo: true,
        handleClose: handleClose,
    };

    return (
        <Popup {...PopupConfig}>
            <p>{i18n.t("timeSlotSelect.earlyOnSite.info.contentOne")}</p>
            <p>{i18n.t("timeSlotSelect.earlyOnSite.info.contentTwo")}</p>
            <Button
                size="SM"
                variant="secondary"
                customStyle="early-on-location__button"
                onClick={handleClose}
                label={i18n.t("timeSlotSelect.earlyOnSite.info.close")}
            ></Button>
        </Popup>
    );
};

EarlyOnLocationInfo.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default EarlyOnLocationInfo;
